import React from 'react';

// --- IMPORTAÇÃO DAS IMAGENS ---
import visaoImg from "../../img/visao.jpg";
import valoresImg from "../../img/valores.jpg";
import missaoImg from "../../img/missao.jpg";

// --- ÍCONES (DEFINIÇÕES - Mantidos) ---
const TargetIcon = (props) => (
  <svg width="63" height="63" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_643_1040)">
      <path d="M11.978 9.39027C-11.9397 31.0371 2.262 70.9991 34.2577 72.8232C35.6723 72.8977 37.1054 72.7674 38.52 72.8232L44.0481 72.0229C50.9721 70.5524 57.2261 67.0346 62.1213 62.1394C64.1128 60.1478 65.8625 57.9515 67.3515 55.5504C67.4632 55.3643 67.5749 55.1781 67.6865 54.992C68.3566 53.8752 68.9708 52.7212 69.5106 51.5486C69.6037 51.3439 69.6967 51.1577 69.7712 50.953C69.9387 50.5621 70.1062 50.1526 70.2737 49.7431C70.4412 49.3337 70.5901 48.9242 70.7391 48.5147C70.8135 48.3099 70.888 48.1052 70.9438 47.9005C71.3533 46.6534 71.7069 45.3691 71.9861 44.0848L72.7865 38.5568V34.2944C71.0927 4.08557 34.6299 -11.1026 11.978 9.39027ZM60.0738 51.772C49.1666 68.5981 24.7465 68.9331 13.225 52.5351C0.158739 33.9035 13.7462 8.19904 36.3423 8.16181C58.6034 8.12459 72.2467 32.9729 60.0738 51.772Z" fill="#202020" />
      <path d="M62.1213 62.1393C64.1129 60.1477 65.8625 57.9514 67.3516 55.5503C65.8625 57.9328 64.0943 60.1477 62.1213 62.1393Z" fill="white" />
      <path d="M67.7051 54.9917C68.3751 53.875 68.9894 52.721 69.5291 51.5483C68.9894 52.7396 68.3751 53.8936 67.7051 54.9917Z" fill="white" />
      <path d="M69.7898 50.953C69.9573 50.5621 70.1248 50.1526 70.2923 49.7432C70.1248 50.1526 69.9573 50.5435 69.7898 50.953Z" fill="white" />
      <path d="M70.2925 49.7431C70.4414 49.3336 70.6089 48.9241 70.7578 48.5146C70.6089 48.9241 70.46 49.3336 70.2925 49.7431Z" fill="white" />
      <path d="M72.0235 44.0847C71.7443 45.3876 71.3907 46.6533 70.9812 47.9003C71.3907 46.6533 71.7443 45.369 72.0235 44.0847Z" fill="white" />
      <path d="M34.5182 15.7C21.4333 16.7609 12.7039 30.0506 16.5195 42.5771C21.3217 58.3423 42.1496 62.3813 52.5542 49.5197C64.1315 35.2063 52.7775 14.2482 34.5182 15.7ZM47.994 41.3859C44.1598 50.4876 31.4843 51.6974 25.9563 43.5077C20.4469 35.3366 26.0866 24.113 35.9514 23.7966C45.1835 23.4988 51.6049 32.8611 47.994 41.3859Z" fill="#202020" />
      <path d="M37.4219 41.7766C29.9209 42.9492 28.7669 32.0606 35.3558 31.0369C42.8569 29.8643 44.0109 40.7529 37.4219 41.7766Z" fill="#202020" />
    </g>
    <defs>
      <clipPath id="clip0_643_1040">
        <rect width="72.8239" height="72.8468" fill="white" />
      </clipPath>
    </defs>
  </svg>

);
const EyeIcon = (props) => (
  <svg width="63" height="64" viewBox="0 0 73 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_643_4606)">
      <path d="M70.5985 32.7838C55.465 14.095 31.7093 8.62794 11.7045 23.6888C8.02254 26.4605 3.79894 30.552 1.10358 34.2897C-0.0263126 35.857 -0.482365 36.7189 0.673588 38.5319C2.97991 42.1431 8.25336 47.1057 11.7045 49.7006C31.7615 64.7689 55.4129 59.3 70.5985 40.6037C71.438 39.5706 72.3966 38.5003 72.8788 37.2643V36.1251C72.3594 34.8965 71.4399 33.8225 70.5985 32.7838ZM48.8029 45.7041C42.3996 54.4249 29.135 54.0265 23.4408 44.7938C17.2087 34.6899 24.325 21.6301 36.1358 21.3676C48.6987 21.0903 56.2989 35.4959 48.8029 45.7041Z" fill="#202020" />
      <path d="M38.4716 44.8241C27.1877 47.592 24.2292 29.7493 35.6283 28.5122C45.8474 27.4062 48.2446 42.4248 38.4716 44.8241Z" fill="#202020" />
    </g>
    <defs>
      <clipPath id="clip0_643_4606">
        <rect width="72.8788" height="73.3941" fill="white" />
      </clipPath>
    </defs>
  </svg>

);
const HeartIcon = (props) => (
  <svg width="65" height="65" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.4809 59.3172L29.6896 74.5012L29.2392 74.9999H28.8005C27.8553 74.3872 25.3118 70.1486 24.5638 69.9418C24.3744 69.8896 24.2932 69.9205 24.1212 69.9418C22.5769 70.1312 20.4721 71.2793 18.92 71.4784C18.4388 71.5402 17.9092 71.604 17.7488 71.0551L22.3701 56.2866C25.161 58.7703 28.1337 57.1255 31.1952 56.3214L34.4809 59.3172Z" fill="#202020" />
    <path d="M57.3982 71.0551C57.2455 71.575 56.8299 71.5305 56.3738 71.4803C55.2064 71.3527 51.2925 69.6924 50.5445 69.907L46.3445 74.9999H45.9077C45.5212 74.7795 45.4303 74.3273 45.2815 73.9426C43.7604 69.9785 42.2258 65.0325 41.0429 60.9311C40.9405 60.5735 40.5887 59.5975 40.6641 59.3172L43.8532 56.3485C46.9224 56.9863 49.926 58.8224 52.7034 56.2847L57.3982 71.0551Z" fill="#202020" />
    <path d="M65.2395 34.1079C64.7949 32.7375 62.3538 29.6973 62.3557 28.582C62.3577 27.5557 64.4663 24.6913 64.9921 23.5452C65.2858 22.9035 65.4405 22.5131 65.0906 21.8231C64.6693 20.992 61.37 19.2872 60.4577 18.4175C59.5802 17.5787 59.7561 17.0278 59.789 15.8565C59.8218 14.7181 60.3476 12.0721 59.9765 11.1483C59.7716 10.638 59.1531 10.4022 58.6583 10.2746C57.4059 9.94993 53.6176 9.8069 52.8483 9.06858C52.1525 8.39983 51.2499 4.81644 50.614 3.69929C50.2855 3.11945 49.7829 2.75222 49.0929 2.80827C47.6105 2.92424 45.4477 4.1129 43.8976 4.35064C42.6645 4.54005 42.2373 3.89257 41.3734 3.14458C40.6582 2.52802 38.6462 0.340097 37.9059 0.173877C37.6682 0.121691 37.4807 0.131355 37.243 0.177742C36.4776 0.326567 34.4946 2.51642 33.7736 3.14458C32.9174 3.89257 32.4748 4.54005 31.2475 4.35064C29.6993 4.1129 27.5365 2.92424 26.0541 2.80827C25.3641 2.75222 24.8615 3.11945 24.533 3.69929C23.8816 4.8435 22.9925 8.44429 22.2117 9.12656C21.4212 9.81657 17.5923 9.93254 16.336 10.2688C15.8992 10.3867 15.2575 10.8081 15.1241 11.2488C14.8342 12.2055 15.3251 14.5828 15.358 15.7096C15.3928 16.9563 15.5996 17.627 14.6081 18.4813C13.7055 19.2582 10.441 21.0596 10.0583 21.825C9.70845 22.5208 9.85728 22.8958 10.1549 23.5452C10.7328 24.8054 12.2172 26.6318 12.6076 27.8166C12.712 28.1356 12.7545 28.3946 12.7313 28.7347C12.6753 29.6199 10.9454 32.0495 10.4506 33.0371C9.75098 34.4326 9.41854 34.8249 10.7483 35.9614C11.5678 36.663 15.0275 38.6171 15.271 39.3341C15.4256 39.7922 15.3754 40.6484 15.358 41.1606C15.3135 42.4092 14.9096 44.2125 15.0546 45.3992C15.1976 46.5512 15.8103 46.6749 16.7825 46.8875C17.9769 47.1465 21.3902 47.3359 22.1518 47.9505C23.2051 48.801 24.0266 53.6271 25.1824 54.1297C26.4213 54.667 29.9525 52.8849 31.4292 52.6917C31.6031 52.6685 31.7133 52.6337 31.9066 52.6588C33.074 52.8018 35.4822 55.9426 36.7037 56.6461C37.2932 56.9844 37.8576 56.9824 38.4432 56.6461C39.6628 55.9426 42.0943 52.7999 43.2404 52.6588C44.3267 52.5235 47.4269 54.0311 48.7953 54.2012C49.7559 54.321 50.154 54.1799 50.6411 53.3449C51.3021 52.2104 52.2183 48.5767 52.9952 47.9505C53.8205 47.2837 57.3285 47.1755 58.6042 46.8353C59.3309 46.642 59.9784 46.3985 60.0944 45.5481C60.3224 43.8704 59.358 40.6562 59.9552 39.2684C60.0538 39.0404 60.1524 38.9302 60.3282 38.764C61.3816 37.7705 63.2467 36.9452 64.3987 35.9614C65.0017 35.4454 65.5178 34.9583 65.2395 34.1079ZM52.8387 38.8761C45.5327 49.6224 29.5988 49.6437 22.3083 38.8761C14.2177 26.9276 22.5151 10.7636 36.812 10.1297L38.0837 10.0891C52.4405 10.6051 61.0608 26.7787 52.8387 38.8761Z" fill="#202020" />
    <path d="M38.3138 20.1124C36.0118 20.7445 34.8657 20.1898 32.6159 21.8693C29.6298 24.0959 29.8443 25.8702 29.1756 29.1019C28.644 31.6744 24.7707 31.5159 24.4286 29.0071C23.5337 22.4415 29.8888 15.955 36.2283 15.3945C37.5078 15.2805 38.7409 15.2051 39.5373 16.3841C40.4457 17.7312 39.9296 19.6698 38.3138 20.1124Z" fill="#202020" />
  </svg>

);

// --- COMPONENTE GENÉRICO DO CARD (MVVCard) ---
const MVVCard = ({ img, title, text, IconComponent }) => {
  // A altura do card é mantida consistente
  const cardHeightClass = "h-[600px]";

  return (
    <div className={`relative w-full ${cardHeightClass} rounded-xl overflow-hidden shadow-xl mx-auto hover:shadow-2xl transition duration-300`}>

      {/* Imagem de Fundo com Desfoque Mínimo */}
      <img
        src={img}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover filter blur-[2.5px]"
      />

      {/* Camada de Conteúdo e Efeito Backdrop */}
      <div
        // ALTERAÇÃO CRUCIAL: justify-between para forçar o topo e base
        className="absolute inset-0 flex flex-col items-center p-6 
                   bg-white/30 backdrop-blur-[0.8px] 
                   text-center"
      >

        {/* PARTE SUPERIOR (Ícone e Título) */}
        <div className="flex flex-col items-center pt-[130px]">

          {/* Ícone proeminente */}
          <div className="mb-6">
            <IconComponent
              className="text-white w-16 h-16 p-2"
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                borderRadius: '50%',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.4)'
              }}
            />
          </div>

          {/* Título */}
          <p className="text-lg font-semibold text-gray-900 mb-3">
            {title}
          </p>
        </div>

        {/* PARTE INFERIOR (Texto Justificado) */}
        <div className="pt-3">
          <p className="text-base leading-tight text-gray-800 leading-relaxed mb-4 text-justify">
            {text}
          </p>
        </div>

      </div>
    </div>
  );
};

// --- COMPONENTE PRINCIPAL (EXPORTADO) ---

export default function MissaoVisaoValores() {

  // Textos... (mantidos)
  const missaoText = (
    <>
      Nossa missão é <b>fornecer soluções em saúde</b> nos segmentos de
      <b> Home Care</b>, <b>Equipamentos Respiratórios</b> e <b>Aparelhos Auditivos </b>
      promovendo o <b>bem-estar</b> e a <b>qualidade de vida</b> de nossos clientes.
      Estamos comprometidos em <b>liderar avanços na medicina</b> e oferecer 
      <b> serviços e produtos inovadores</b> para <b>melhorar a saúde</b>.
    </>
  );

  const visaoText = (
    <>
      Ser <b>reconhecidos como líderes</b> na transformação de <b>soluções em saúde</b>,
      estabelecendo um <b>novo padrão</b> para a <b>qualidade dos nossos serviços</b> e proporcionando
      <b> soluções inovadoras</b> que inspirem <b>mudanças positivas</b> na <b>vida dos nossos clientes.</b>
    </>
  );

  const valoresText = (
    <>
      <b>Excelência:</b> Buscar a excelência em tudo que fazemos, garantindo a mais alta qualidade nos serviços e produtos oferecidos.
      <br />
      <b>Compromisso:</b> Colocar o cliente em primeiro lugar, respeitando sua dignidade, privacidade e necessidades individuais.
      <br />
      <b>Inovação:</b> Estimular a inovação contínua, explorando novas tecnologias, terapias e abordagens.
      <br />
      <b>Ética:</b> Agir com integridade, ética e responsabilidade em todas as interações e decisões.
    </>
  );


  return (
    <section
      // ALTERAÇÃO: gap-10 para gap-6
      className="max-w-6xl mx-auto px-6 pb-20 grid md:grid-cols-3 gap-4"
    >
      <MVVCard
        img={missaoImg}
        title="Missão"
        text={missaoText}
        IconComponent={TargetIcon}
      />
      <MVVCard
        img={visaoImg}
        title="Visão"
        text={visaoText}
        IconComponent={EyeIcon}
      />
      <MVVCard
        img={valoresImg}
        title="Valores"
        text={valoresText}
        IconComponent={HeartIcon}
      />
    </section>
  );
}